import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';

export const SECTION_HEADER_PLUGIN_ID = 'sectionHeader' as const;
export type SectionHeaderPluginID = typeof SECTION_HEADER_PLUGIN_ID;

export type SectionHeaderPluginElement = Readonly<
  EditorElement & {
    type: SectionHeaderPluginID;
    conceptID: string;
    viewerRefID: string;
  }
>;

export type SectionHeaderPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: any;
  }
>;

export type SectionHeaderPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    SectionHeaderPluginOptions & {
      pluginID: SectionHeaderPluginID;
      pluginName: string;
      component: any;
    }
>;
